export enum KeyboardShortcutScope {
  DEFAULT = 'all',
  POSTER_EDITOR = 'PosterEditor',
  VERSION_HISTORY = 'VersionHistory',
  ITEM_SHAPE_MASKING = 'ItemShapeMasking',
  ITEM_TEXT_MASKING = 'ItemTextMasking',
  ITEM_POINT_MASKING = 'ItemPointMasking',
}
